app.service('productAvailability', function(
	modal,
	localStorage,
	geolocation,
	productCardConfig,
	productAvailabilityService,
	productAvailabilityShopList,
	productAvailabilityShopMap,
	productAvailabilityShopTabs,
	productAvailabilitySearch,
	log
) {
	let searchShopModal,
		state = {
			modalInstance: false,
			city: '',
			cityCode: '',
			shopCode: ''
		};

	let $self, $selectedShopBox;

	const AVAILABLE_IN_SHOPS_STATUS = '6';

	function setState(newState) {
		$.extend(state, newState);
	}

	function persistState() {
		const { city, cityCode, shopCode } = state;
		const stateToPersist = { city, cityCode, shopCode };

		localStorage.setItem('user_shop_data', JSON.stringify(stateToPersist));
	}

	function showModal() {
		if (searchShopModal) {
			searchShopModal.open();
			return false;
		}

		searchShopModal = modal.generate({
			id: 'search-shop-modal',
			header: 'Sprawdź dostępność',
			content: $('.availability-modal'),
			modifier: 'remodal-full-width'
		});
	}

	function getUserShopData() {
		return JSON.parse(localStorage.getItem('user_shop_data'));
	}

	function isAvailableInShopsStatus() {
		return (
			productCardConfig.getData().productAvailabilityStatusCode ===
			AVAILABLE_IN_SHOPS_STATUS
		);
	}

	function renderShops(data) {
		if (isAvailableInShopsStatus()) {
			data = $.extend({}, data, { onlyAvailableToOrder: false });
		}
		productAvailabilityService.getAllShops(data).then(shopsHtml => {
			productAvailabilityShopMap.update(shopsHtml);
			productAvailabilityShopList.update(shopsHtml);
			productAvailabilityShopTabs.showList();

			const shops = $(shopsHtml).find('.shop-item').length;

			if (!shops) {
				productAvailabilityShopTabs.showInfoMessage();
			} else {
				setActiveShop();
			}
		});
	}

	function handleFindShopsWithProduct(e) {
		const { id: product_id } = productCardConfig.getData();
		const { checked: onlyAvailable } = e.target;
		const { cityCode: city } = state;

		productAvailabilityShopMap.hideInfo();

		const shopsData = {
			product_id,
			onlyAvailable,
			showAllAvailableShops: false
		};

		if (city) {
			const data = $.extend(shopsData, { city });

			renderShops(data);
		} else {
			geolocation.findPosition(position => {
				const data = $.extend(shopsData, position.coords);

				renderShops(data);
			});
		}
	}

	function setActiveShop(shopCode = state.shopCode) {
		$('.shop-item').removeClass('is-active');

		if (shopCode) {
			$(`.shop-item[data-shop=${shopCode}]`).addClass('is-active');
		}
	}

	function handleSelectShop(e) {
		e.stopPropagation();

		const shopCode = $(this).data('shop-code');

		if (state) {
			if (String(state.shopCode) === String(shopCode)) {
				$self.removeClass('show-selected-shop');

				localStorage.removeItem('user_shop_data');

				state.shopCode = '';

				setActiveShop();

				return false;
			}
		}

		$self.removeClass('loading');

		setState({ shopCode });

		persistState(state);

		setActiveShop();

		const { id: productId } = productCardConfig.getData();

		productAvailabilityService
			.getShop({
				shopCode,
				productId
			})
			.then(html => {
				$selectedShopBox.html(html);

				$self.addClass('show-selected-shop');
			});

		closeModal();
	}

	function closeModal() {
		searchShopModal.close();
	}

	function showUserShopDetails(html) {
		$selectedShopBox.html(html);
	}

	function checkIfShopHasBeenSelected() {
		const shopData = getUserShopData();

		if (!shopData) {
			$self.removeClass('loading show-selected-shop');
			return false;
		}

		setState(shopData);

		const { shopCode } = shopData;
		const { id: productId } = productCardConfig.getData();

		productAvailabilityService
			.getShop({
				shopCode,
				productId
			})
			.then(html => {
				showUserShopDetails(html);

				$self.removeClass('loading').addClass('show-selected-shop');
			});
	}

	function changeShop() {
		initModalServicesOnce();

		const {
			id: product_id,
			buyableOnlyInShop: onlyAvailable
		} = productCardConfig.getData();
		const { cityCode } = state;

		showModal();

		renderShops({
			city: cityCode,
			product_id,
			onlyAvailable
		});
	}

	function handleFindNearStore() {
		geolocation.findPosition(position => {
			const { id: product_id } = productCardConfig.getData();
			const { latitude, longitude } = position.coords;

			renderShops({
				product_id,
				latitude,
				longitude,
				onlyAvailable: false
			});
		});
	}

	function handleShowAvailableShops() {
		const { id: product_id } = productCardConfig.getData();
		const { cityCode } = state;

		renderShops({
			product_id,
			onlyAvailable: true,
			showAllAvailableShops: true,
			city: cityCode
		});
	}

	function initModalServicesOnce() {
		if (state.modalInstance) {
			return false;
		}

		productAvailabilityShopMap.init();
		productAvailabilityShopTabs.init();
		productAvailabilityShopList.init(state);
		productAvailabilitySearch.init({ setState, renderShops, closeModal });

		state.modalInstance = true;
	}

	function makeReservation(data) {
		productAvailabilityService.makeReservation(data);
	}

	function handleReserveButtonClick() {
		const { shopCode } = state;

		if (!shopCode) {
			initModalServicesOnce();
			showModal();
			return;
		}

		if (isAvailableInShopsStatus()) {
			changeShop();
			return;
		}

		const { id: productId } = productCardConfig.getData();

		makeReservation({
			shopCode,
			productId
		});
	}

	function setEvents() {
		$self.on('click', '.js-change-shop', changeShop);

		$('body').on('click', '.js-delivery-city', () => {
			initModalServicesOnce();
			showModal();
			UA.interaction('KP','CTA','Sprawdź dostępność w sklepach');
			log.recommendationsForAWS({
				productPlu: productCardConfig.getData().plu,
				eventCategory: 'Dostepność produktu',
				eventAction: 'Obejrzyj w sklepie'
			});
		});

		$('body').on('click', '.js-reserve', handleReserveButtonClick);

		$('body').on('click', '.js-find-near-store', handleFindNearStore);

		$('body').on(
			'click',
			'.js-find-shops-with-product',
			handleFindShopsWithProduct
		);

		$('body')
			.on('click', '.js-select-shop', handleSelectShop)

		$('body').on(
			'click',
			'.js-show-all-available-shops',
			handleShowAvailableShops
		);
	}

	function setElements() {
		$self = $('.product-availability');
		$selectedShopBox = $self.find('.selected-shop-box');
	}

	function init() {
		setElements();
		setEvents();

		checkIfShopHasBeenSelected();
	}

	return { init };
});
